import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

export interface StatusDistribution {
  total: number;
  newAlarms: number;
  inProgress: number;
  resolved: number;
  closed: number;
  newPercentage: number;
  inProgressPercentage: number;
  resolvedPercentage: number;
  closedPercentage: number;
}

export interface StatusSummary {
  total: number;
  unclassified: number;
  classified: number;
  unclassifiedPercentage: number;
  classifiedPercentage: number;
}

export interface StatusType {
  status: string;
  count: number;
  percentage: number;
  unclassified?: boolean;
}

export interface EventDistribution {
  eventName: string;
  count: number;
  percentage: number;
}

export interface TopResolver {
  resolverName: string;
  resolverId: string;
  classifiedCount: number;
}

export interface AlarmTimeSeries {
  timestamp: string;
  count: number;
}

export interface AlarmDashboardData {
  statusDistribution: StatusDistribution;
  statusSummary: StatusSummary;
  statusTypeDistribution: StatusType[];
  eventDistribution: EventDistribution[];
  topResolvers: TopResolver[];
  alarmTimeSeries: AlarmTimeSeries[];
}

@Injectable({
  providedIn: 'root',
})
export class AlarmsDashboardService {
  constructor(private http: HttpClient) {}

  getDashboardData(): Observable<AlarmDashboardData> {
    // Return mock data for demonstration
    const mockData: AlarmDashboardData = {
      statusDistribution: {
        total: 1000,
        newAlarms: 50,
        inProgress: 250,
        resolved: 500,
        closed: 200,
        newPercentage: 5,
        inProgressPercentage: 25,
        resolvedPercentage: 50,
        closedPercentage: 20,
      },
      statusSummary: {
        total: 1000,
        unclassified: 150,
        classified: 850,
        unclassifiedPercentage: 15,
        classifiedPercentage: 85,
      },
      statusTypeDistribution: [
        {
          status: 'Sin clasificar',
          count: 150,
          percentage: 15,
          unclassified: true,
        },
        {
          status: 'Clasificada',
          count: 850,
          percentage: 85,
          unclassified: false,
        },
      ],
      eventDistribution: [
        {
          eventName: 'Theft/panic',
          count: 300,
          percentage: 30,
        },
        {
          eventName: 'Speeding',
          count: 250,
          percentage: 25,
        },
        {
          eventName: 'Accident',
          count: 200,
          percentage: 20,
        },
        {
          eventName: 'Other',
          count: 250,
          percentage: 25,
        },
      ],
      topResolvers: [
        {
          resolverName: 'John Doe',
          resolverId: 'user123',
          classifiedCount: 150,
        },
        {
          resolverName: 'Jane Smith',
          resolverId: 'user456',
          classifiedCount: 120,
        },
        {
          resolverName: 'Mike Johnson',
          resolverId: 'user789',
          classifiedCount: 95,
        },
        {
          resolverName: 'Sarah Wilson',
          resolverId: 'user101',
          classifiedCount: 85,
        },
        {
          resolverName: 'David Brown',
          resolverId: 'user202',
          classifiedCount: 70,
        },
        {
          resolverName: 'Lisa Davis',
          resolverId: 'user303',
          classifiedCount: 65,
        },
      ],
      alarmTimeSeries: [
        {
          timestamp: '2024-01-01T00:00:00',
          count: 45,
        },
        {
          timestamp: '2024-01-02T00:00:00',
          count: 52,
        },
        {
          timestamp: '2024-01-03T00:00:00',
          count: 38,
        },
        {
          timestamp: '2024-01-04T00:00:00',
          count: 61,
        },
        {
          timestamp: '2024-01-05T00:00:00',
          count: 49,
        },
      ],
    };
    return of(mockData);
  }

  
}
